import React from 'react';
import { 
  FiHome, 
  FiUsers, 
  FiFileText, 
  FiActivity,
  FiTrendingUp,
  FiAlertCircle,
  FiDollarSign,
  FiCheckCircle,
  FiXCircle,
  FiPieChart,
  FiBarChart2
} from 'react-icons/fi';

const AdminDashboard = () => {
  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    primaryLight: '#e6f0ef',
    text: '#333333'
  };

  const stats = [
    {
      title: 'एकूण ग्रामपंचायती',
      value: '१२०',
      icon: <FiHome size={24} />,
      color: '#085e53',
      bg: '#e6f0ef'
    },
    {
      title: 'सक्रिय ग्रामपंचायती',
      value: '११५',
      icon: <FiCheckCircle size={24} />,
      color: '#10b981', // Emerald
      bg: '#ecfdf5'
    },
    {
      title: 'निष्क्रिय ग्रामपंचायती',
      value: '०५',
      icon: <FiXCircle size={24} />,
      color: '#ef4444', // Red
      bg: '#fef2f2'
    },
    {
      title: 'आजचे अर्ज',
      value: '४५',
      icon: <FiFileText size={24} />,
      color: '#3b82f6', // Blue
      bg: '#eff6ff'
    },
    {
      title: 'प्रलंबित अर्ज',
      value: '१२',
      icon: <FiAlertCircle size={24} />,
      color: '#f59e0b', // Amber
      bg: '#fffbeb'
    },
    {
      title: 'महसूल संकलन (रु.)',
      value: '१२,५०,०००',
      icon: <FiDollarSign size={24} />,
      color: '#8b5cf6', // Violet
      bg: '#f5f3ff'
    },
    {
      title: 'जन्म / मृत्यू दाखला',
      value: '२८',
      icon: <FiActivity size={24} />,
      color: '#ec4899', // Pink
      bg: '#fdf2f8'
    },
    {
      title: 'तक्रारी संख्या',
      value: '०८',
      icon: <FiTrendingUp size={24} />,
      color: '#6366f1', // Indigo
      bg: '#eef2ff'
    }
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800">मुख्य डॅशबोर्ड</h1>
        <p className="text-gray-600">प्रशासन कक्ष - ग्राम पंचायत डिजिटल गव्हर्नन्स</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <div 
                className="p-3 rounded-lg"
                style={{ backgroundColor: stat.bg, color: stat.color }}
              >
                {stat.icon}
              </div>
              <span className="text-sm font-medium text-gray-400">अद्यतन: आज</span>
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-1">{stat.value}</h3>
            <p className="text-sm text-gray-500 font-medium">{stat.title}</p>
          </div>
        ))}
      </div>

      {/* Charts Section Placeholder */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg font-bold text-gray-800">मासिक महसूल संकलन</h2>
            <FiBarChart2 size={20} className="text-gray-400" />
          </div>
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <p className="text-gray-500">येथे चार्ट दर्शविला जाईल</p>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg font-bold text-gray-800">निधी वापर टक्केवारी</h2>
            <FiPieChart size={20} className="text-gray-400" />
          </div>
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded-lg border border-dashed border-gray-300">
            <p className="text-gray-500">येथे चार्ट दर्शविला जाईल</p>
          </div>
        </div>
      </div>

      {/* Recent Activity Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800">अलीकडील अर्ज</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 text-gray-600 text-sm">
                <th className="p-4 font-semibold">अर्ज क्रमांक</th>
                <th className="p-4 font-semibold">अर्जदार</th>
                <th className="p-4 font-semibold">प्रकार</th>
                <th className="p-4 font-semibold">दिनांक</th>
                <th className="p-4 font-semibold">स्थिती</th>
                <th className="p-4 font-semibold">कृती</th>
              </tr>
            </thead>
            <tbody className="text-sm divide-y divide-gray-100">
              {[1, 2, 3, 4, 5].map((item) => (
                <tr key={item} className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 font-medium text-gray-800">#APP-{202400 + item}</td>
                  <td className="p-4 text-gray-600">राजेश पाटील</td>
                  <td className="p-4 text-gray-600">जन्म दाखला</td>
                  <td className="p-4 text-gray-600">२०/०२/२०२६</td>
                  <td className="p-4">
                    <span className="px-2 py-1 rounded bg-yellow-100 text-yellow-700 text-xs font-semibold">
                      प्रलंबित
                    </span>
                  </td>
                  <td className="p-4">
                    <button className="text-teal-700 hover:text-teal-900 font-medium">पहा</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;